import { render, staticRenderFns } from "./ViewportBottom.vue?vue&type=template&id=eddfc102&scoped=true"
import script from "./ViewportBottom.vue?vue&type=script&lang=js"
export * from "./ViewportBottom.vue?vue&type=script&lang=js"
import style0 from "./ViewportBottom.vue?vue&type=style&index=0&id=eddfc102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddfc102",
  null
  
)

export default component.exports